export default {
  get: {
    funKey: 'get',
    name: '查看',
    apis: [{
      path: '/basis/rew_pun',
      method: 'GET'
    }]
  },
  add: {
    funKey: 'add',
    name: '新增',
    apis: [{
      path: '/basis/rew_pun',
      method: 'POST'
    },
    {
      path: '/basis/worker',
      method: 'GET'
    }]
  },
  update: {
    funKey: 'edit',
    name: '修改',
    apis: [{
      path: '/basis/rew_pun/{id}',
      method: 'PUT'
    },
    {
      path: '/basis/worker',
      method: 'GET'
    }]
  },
  del: {
    funKey: 'del',
    name: '删除',
    apis: [{
      path: '/basis/rew_pun/{id}',
      method: 'DELETE'
    }]
  }
}